import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  KoBreadcrumb, KoToast, KoTitle,
  KoForm, KoDescription, KoLoader,
  KoButton,
  KoTabs,
  KoModal,
  KoNano
} from 'packages';
import KoIcon from '@kwapio/icons';
import { deepMerge } from 'shared/utils';

import BusinessInfoCurd from './curd/business';
import BusinessProfile from './curd/businessprofile';
import PreferencesCrud from './curd/preferences';
import AddressCrud from './curd/address';
import DiscountCrud from './curd/discount';
import TaxCrud from './curd/tax';
// import Preview from './preview';
import { add, remove } from 'shared/store/breadcrumbSlice';
import BankCrud from './curd/bank';
import { ClientsAPI } from '../../customers.service';

import styles from './settings.module.scss';



function ClientDetails(props) {
  const { isBack, customerId, setCurrentRecord, openCustomerModal, getCustomers, setOpenCustomerModal } = props;
  const [isLoading, setLoading] = useState(false);
  const [form] = KoForm.useForm();


  const [settings, setSettings] = useState({
    preferences: {
      "defaultLanguage": "en",
      "primaryCurrency": "inr",
      "currencyPosition": "right",
      "numberFormat": "comma_dot",
      "dateFormat": "DD-MM-YYYY",
      "timeFormat": "12H",
      "financialYearBegins": "March",
      "invoiceNoPrefix": "INV"
    }
  });
  const dispatch = useDispatch();


  useEffect(() => {
    dispatch(remove());
    dispatch(add([
      {
        title: 'Admin Console',
        path: 'admin/settings'
      },
      {
        title: 'Customers',
        path: 'admin/customers'
      },
      {
        title: settings?.companyName
      }
    ]));
  }, [settings]);

  const panelStyle = {
    marginBottom: 2,
    background: '#fff',
    border: 'none',
    borderRadius: 1
  };

  useEffect(() => {
    if (customerId) {
      getClientsById(customerId);
    } else {
      form.setFieldsValue({
        preferences: {
          "defaultLanguage": "en",
          "primaryCurrency": "inr",
          "currencyPosition": "right",
          "numberFormat": "comma_dot",
          "dateFormat": "DD-MM-YYYY",
          "timeFormat": "12H",
          "financialYearBegins": "March",
          "invoiceNoPrefix": "INV"
        }
      });
    }
  }, []);

  const getClientsById = (clientId) => {
    setLoading(true);
    ClientsAPI.getClientById(clientId).then(
      (data) => {
        setLoading(false);
        setSettings(data?.customer);

        form.setFieldsValue(Object.assign(settings, data?.customer));



        dispatch(add([
          {
            title: 'Customers',
            path: 'customers'
          },
          {
            title: data?.customer?.companyName
          }
        ]));
      },
      (err) => {
        setLoading(false);
      }
    );
  };


  const onValuesChange = (changedValues, refresh) => {
    const updatedCObj = deepMerge(settings, changedValues);
    if (refresh === 'refresh') {
      handleFinish(updatedCObj, refresh);
      setSettings(updatedCObj);
    }
  };

  const handleFinish = useCallback((values, refresh) => {
    setLoading(true);
    let settingsObject = Object.assign(settings, values);
    if (!customerId) {
      settingsObject['customerId'] = KoNano('CUS');
      settingsObject['status'] = 1;
      settingsObject['type'] = 1;
    }
    ClientsAPI.createOrUpdateClient(settingsObject, customerId).then(
      (data) => {
        setLoading(false);
        if(customerId){
          getClientsById(customerId);
        }
        getCustomers && getCustomers();
        // setOpenCustomerModal(false);
        if (refresh !== 'refresh') {
          KoToast.success(`Customer ${settings?.customerId ? 'updated' : 'created'}  successfully`);
        }
      },
      (err) => {
        setLoading(false);
      }
    );
  });

  const HEADER_OPTIONS = [{
    label: <div className={styles.header}>
      <div className={styles.circle}>
        <KoIcon name="BusinessFilled" height={12} width={12} />
      </div>
      <div className={styles.title}>
        <KoTitle className={styles.title} level={5} text="Business Information" />
        {/* <KoDescription className={styles.description} text="Details about your business information" /> */}
      </div>
    </div>,
    children: <>
      <KoForm form={form} layout="vertical" onFinish={handleFinish} onSubmit={handleFinish}>
        <BusinessInfoCurd onValuesChange={onValuesChange} settings={settings} form={form} />
      </KoForm>
    </>
    ,
    key: 1,
    style: panelStyle
  },
  {
    label: <div className={styles.header}>
      <div className={styles.circle}>
        <KoIcon name="BusinessProfileFilled" height={15} width={15} />
      </div>
      <div className={styles.title}>
        <KoTitle className={styles.title} level={5} text="Business Profile" />
        {/* <KoDescription className={styles.description} text="Details about your business profile" /> */}
      </div>
    </div>,
    children: <>
      <KoForm form={form} layout="vertical" onFinish={handleFinish} onSubmit={handleFinish}>
        <BusinessProfile settings={settings} form={form} />
      </KoForm>
    </>,
    key: 2,
    style: panelStyle
  }, {
    label: <div className={styles.header}>
      <div className={styles.circle}>
        <KoIcon name="PreferencesFilled" height={12} width={12} />
      </div>
      <div className={styles.title}>
        <KoTitle className={styles.title} level={5} text="General Preferences" />
        {/* <KoDescription className={styles.description} text="Describe about your general preferences" /> */}
      </div>
    </div>,
    children: <>
      <KoForm form={form} layout="vertical" onFinish={handleFinish} onSubmit={handleFinish}>
        <PreferencesCrud settings={settings} form={form} />
      </KoForm>
    </>,
    key: 3,
    style: panelStyle
  }, {
    label: <div className={styles.header}>
      <div className={styles.circle}>
        <KoIcon name="LocationFilled" height={20} width={20} />
      </div>
      <div className={styles.title}>
        <KoTitle className={styles.title} level={5} text="Address Information" />
        {/* <KoDescription className={styles.description} text="Details about organization  location" /> */}
      </div>
    </div>,
    children: <>
      <KoForm form={form} layout="vertical" onFinish={handleFinish} onSubmit={handleFinish}>
        <AddressCrud settings={settings} form={form} />
      </KoForm>
    </>,
    key: 4,
    style: panelStyle
  }, {
    label: <div className={styles.header}>
      <div className={styles.circle}>
        <KoIcon name="BankFilled" height={14} width={14} />
      </div>
      <div className={styles.title}>
        <KoTitle className={styles.title} level={5} text="Bank Details" />
        {/* <KoDescription className={styles.description} text="Details about organization bank info" /> */}
      </div>
    </div>,
    children: <>
      <KoForm form={form} layout="vertical" onFinish={handleFinish} onSubmit={handleFinish}>
        <BankCrud settings={settings} form={form} />
      </KoForm>
    </>,
    key: 5,
    style: panelStyle
  }, {
    label: <div className={styles.header}>
      <div className={styles.circle}>
        <KoIcon name="TaxFilled" height={12} width={12} />
      </div>
      <div className={styles.title}>
        <KoTitle className={styles.title} level={5} text="Tax Details" />
        {/* <KoDescription className={styles.description} text="Details about your tax levied directly" /> */}
      </div>
    </div>,
    children: <>
      <KoForm form={form} layout="vertical" onFinish={handleFinish} onSubmit={handleFinish}>
        <TaxCrud settings={settings} form={form} />
      </KoForm>
    </>,
    key: 6,
    fields: 2,
    outof: 5,
    style: panelStyle
  }, {
    label: <div className={styles.header}>
      <div className={styles.circle}>
        <KoIcon name="DiscountFilled" height={16} width={16} />
      </div>
      <div className={styles.title}>
        <KoTitle className={styles.title} level={5} text="Discount Details" />
        {/* <KoDescription className={styles.description} text="Details about your discount rates" /> */}
      </div>
    </div>,
    children: <>
      <KoForm form={form} layout="vertical" onFinish={handleFinish} onSubmit={handleFinish}>
        <DiscountCrud settings={settings} form={form} />
      </KoForm>
    </>,
    key: 7,
    style: panelStyle
  }];

  return (
    <KoModal
      title={`${settings?.companyName?.toUpperCase() || 'Create Customer'}`}
      centered
      open={openCustomerModal}
      afterClose={() => { setCurrentRecord(); }}
      handleOk={() => { setCurrentRecord(); setOpenCustomerModal(false); }}
      onClose={() => { setCurrentRecord(); setOpenCustomerModal(false); }}
      width={'80vw'}
      footer={[
        <KoButton key='cancel' label='Cancel' onClick={() => setOpenCustomerModal(false)} />,
        <KoButton key='reset' loading={isLoading} type='primary' label={`${customerId ? 'Update' : 'Create'}`} onClick={() => form.submit()} />,
        <KoButton key='update' loading={isLoading} type='primary' label={`${customerId ? 'Update & Close' : 'Create & Close'}`} onClick={() => {form.submit(); setOpenCustomerModal(false);}} />
      ]}
    >
      {isLoading && <KoLoader circle={false} />}
      <div className={`${styles.layout} profileSection`}>
        {isLoading && <KoLoader />}
        <div className={styles.saveAction}>
          <KoBreadcrumb items={[
            {
              title: <div className={styles.breadcrumb}>
                {isBack && <Link className={styles.back} to="/clients">
                  <KoIcon name={'ArrowLeftOutlined'} />
                </Link>}
                <KoTitle className={styles.title} strong={true} level={5} text={`Customer Settings.`} />
              </div>
            }
          ]} />
          <KoDescription className={styles.descriptionTitle} text={`Configure preferences, profiles, and details for the customer.
All changes made here will apply only to this customer.`} />
        </div>
        <div className={styles.wrapper}>
          <KoTabs options={HEADER_OPTIONS} />
        </div>
      </div>
    </KoModal>
  );
}

export default ClientDetails;